/* DEM PADEL — Override PDP rating display for textile/accessoire
   Les raquettes ont des valeurs explicites en Liquid. Pour le reste,
   on génère un nombre d'avis 3-7 et une note 4.6-4.9 déterministe via hash du handle. */
(function(){
  const raquetteHandles = new Set(['prestige-12k','tormenta-12k','sombra-12k','armonia-3k','aire','agua','fuego']);
  const path = window.location.pathname.replace(/^\//,'');
  if (!path.startsWith('products/')) return;
  const handle = path.replace('products/','').split(/[?#/]/)[0];
  if (raquetteHandles.has(handle)) return;

  // Hash deterministe du handle
  let hash = 0;
  for (let i=0; i<handle.length; i++) {
    hash = ((hash * 31) + handle.charCodeAt(i)) >>> 0;
  }
  hash = hash % 100;

  const count = (hash % 5) + 3; // 3-7
  const ratings = [4.6, 4.7, 4.8, 4.9];
  const rating = ratings[Math.floor(hash / 25)];

  function update(){
    // Lien sous le titre PDP
    const ratingLink = document.querySelector('.pdp__rating a');
    if (ratingLink) {
      ratingLink.innerHTML = '<strong>' + rating + '</strong> · ' + count + ' avis';
    }
    // Etoiles partielles (stars__fg width)
    const starsFg = document.querySelectorAll('.pdp__rating .stars__fg');
    starsFg.forEach(el => { el.style.setProperty('--star-pct', (rating / 5 * 100) + '%'); el.style.width = (rating / 5 * 100) + '%'; });
    // Texte sous-titre section avis ("★★★★★ X / 5 • N avis vérifiés")
    const reviewsSub = document.querySelector('#avis .pdp-block__sub');
    if (reviewsSub) {
      reviewsSub.textContent = '★★★★★ ' + rating + ' / 5 • ' + count + ' avis vérifiés de nos joueurs';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
